<template>
  <article
    v-if="tile"
    class="cms-colorlist"
    :data-colorlist-region="settings.regionUUID"
    @click="navigate"
  >
    <header class="cms-colorlist__header">
      <div v-if="tile.shortName || tile.raceStatus || tile.date" class="cms-colorlist__meta">
        <span class="cms-colorlist__category">
          <span v-if="tile.shortName">{{ tile.shortName }}</span>
          <span v-if="tile.shortName && tile.raceStatus" aria-hidden="true"> · </span>
          <span
            v-if="tile.raceStatus"
            class="cms-colorlist__status"
            :style="{
              '--status-light': tile.raceStatus.textColors[0],
              '--status-dark': tile.raceStatus.textColors[1],
            }"
            >{{ tile.raceStatus.label }}</span
          >
        </span>
        <span v-if="tile.date" class="cms-colorlist__date">{{ tile.date }}</span>
      </div>
      <h3 class="cms-colorlist__title">
        <router-link :to="route()" :target="linkTarget" rel="noopener" @click="track">{{
          tile.title
        }}</router-link>
      </h3>
      <p v-if="summaryText" class="cms-colorlist__summary">{{ summaryText }}</p>
    </header>
    <div class="cms-colorlist__rows">
      <div
        v-for="row in tile.rows"
        :key="row.id"
        class="cms-colorlist__row"
        :class="{ 'cms-colorlist__row--leader': row.isLeader }"
        :data-contract-id="row.id"
        :style="{ '--contract-color': row.color }"
      >
        <span class="cms-colorlist__bar" aria-hidden="true"></span>
        <span class="cms-colorlist__portrait" aria-hidden="true">
          <span v-if="row.overlay">{{ row.overlay }}</span>
          <img
            v-else-if="row.image && !failedImages[row.id]"
            :src="row.image"
            alt=""
            @error="failedImages[row.id] = true"
          />
          <span v-else>{{ initials(row.name) }}</span>
        </span>
        <div class="cms-colorlist__identity">
          <div class="cms-colorlist__name-line">
            <span v-if="row.isLeader" class="visually-hidden">Leading contract</span>
            <router-link
              class="cms-colorlist__name"
              :to="route(row.id)"
              :target="linkTarget"
              rel="noopener"
              @click="track"
              >{{ row.name }}</router-link
            >
          </div>

          <span v-if="row.subtitle" class="cms-colorlist__subtitle">{{ row.subtitle }}</span>
        </div>
        <svg
          v-if="row.sparkline"
          class="cms-colorlist__sparkline"
          :class="{ 'is-up': row.sparkline.trend > 0, 'is-down': row.sparkline.trend < 0 }"
          viewBox="0 0 64 30"
          role="img"
          :aria-label="`${row.name}: ${tile.numDays}-day price history`"
        >
          <line class="cms-colorlist__reference" x1="2" x2="62" y1="15" y2="15" />
          <path
            :d="row.sparkline.path"
            fill="none"
            stroke="currentColor"
            stroke-width="1.2"
            stroke-linejoin="round"
          />
        </svg>
        <div class="cms-colorlist__quote">
          <button
            type="button"
            class="cms-colorlist__price"
            :data-price="row.display"
            :disabled="disabled(row)"
            :aria-label="`Trade ${row.name}, ${row.display}`"
            @click.stop="trade(row, $event)"
          >
            {{ row.display }}
          </button>
          <span
            class="cms-colorlist__change"
            :class="{ 'is-up': row.change > 0, 'is-down': row.change < 0 }"
          >
            <market-change-price
              v-if="row.change !== null && row.change !== 0"
              :price="row.change"
              :symbol="tile.symbol"
            />
            <span v-else>–</span
            ><span v-if="tile.changeLabel" class="cms-colorlist__days">{{ tile.changeLabel }}</span>
          </span>
        </div>
      </div>
    </div>
    <footer class="cms-colorlist__footer">
      <span v-if="tile.spread !== null">Spread {{ tile.spread }}{{ tile.symbol }}</span>
      <span v-if="tile.contractCount" class="cms-colorlist__count">{{ tile.contractCount }}</span>
      <span class="cms-colorlist__hint">Click price to trade</span>
    </footer>
  </article>
</template>
<script src="./market-contract-list-colorlist.js"></script>
<style src="./market-contract-list-colorlist.scss" lang="scss"></style>
